import Component from '@glimmer/component';
import { filter, filterBy } from 'macro-decorators';

export default class FloorCardComponent extends Component {
  @filter('args.floor.desks.content', (desk) => desk.xPos && desk.yPos) placedDesks;
  @filterBy('args.floor.desks.content', 'enabled') enabledDesks;
}
